var _g, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPointsFocusOff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPointsFocusOff);
export default __webpack_public_path__ + "static/media/ic_action_points_focus_off.4997c7837900ff13fe1ad73da22d4afe.svg";
export { ForwardRef as ReactComponent };